<template>
  <div class="track-container">
    <!-- 介绍物流有多牛逼的模块 -->
    <track-map></track-map>
    <!-- 运输路线模块 -->
    <track-way></track-way>
    <!-- 运输纵览面板 -->
    <track-panel></track-panel>
  </div>
</template>

<script>
import TrackMap from '@/views/track/components/TrackMap'
import TrackWay from '@/views/track/components/TrackWay'
import TrackPanel from '@/views/track/components/TrackPanel'

export default {
  name:'trackIndex',
  components:{TrackWay,TrackMap,TrackPanel},
  data() {
    return {
      
    }
  },
}
</script>

<style lang="less" scoped>

</style>